import 'swiper/css'
import 'swiper/css/pagination'
import { register } from 'swiper/element/bundle'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import type { CustomDefineComponent } from '../types/components'
import './Swiper.scss'

register()

type SwiperSlideProps = {
  children: CustomDefineComponent[]
}

type SwiperProps = VueComponentProps<typeof Swiper>

export const SwiperContainer = defineComponent<SwiperProps>({
  inheritAttrs: false,
  name: 'Swiper',
  setup(_, { slots, attrs }) {
    const swiperRef = ref()
    const props = attrs as SwiperProps

    return () => {
      const defaultSlots: SwiperSlideProps[] = (slots.default?.() as unknown as SwiperSlideProps[]) || []
      const children = defaultSlots.map((item) => item.children).flat()

      return (
        <div class="swiper-layout">
          <div class={'swiper-container'} ref={swiperRef}>
            <Swiper modules={[Pagination]} pagination autoplay {...props}>
              {children.map((item) => {
                return <SwiperSlide key={item.key}>{item}</SwiperSlide>
              })}
            </Swiper>
          </div>
        </div>
      )
    }
  },
})
